import { render, staticRenderFns } from "./worker.vue?vue&type=template&id=2e6d0e8c&scoped=true"
import script from "./worker.vue?vue&type=script&lang=js"
export * from "./worker.vue?vue&type=script&lang=js"
import style0 from "./worker.vue?vue&type=style&index=0&id=2e6d0e8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6d0e8c",
  null
  
)

export default component.exports